// plugins/iframeResizer.js

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    function sendHeight() {
      const height = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight,
      )
      window.parent.postMessage({ height }, '*')
    }

    // Send height on initial load
    window.addEventListener('load', sendHeight)

    // Send height on window resize
    window.addEventListener('resize', () => {
      setTimeout(sendHeight, 100) // Slight delay to allow content to reflow
    })

    // Wait for app to be mounted before setting up route change listener
    nuxtApp.hook('app:mounted', () => {
      // Send height when the route changes
      nuxtApp.$router.afterEach(() => {
        setTimeout(sendHeight, 0)
      })
    })

    // Send height periodically to account for dynamic content changes
    const intervalId = setInterval(sendHeight, 500)

    // Clean up interval on page unload
    window.addEventListener('unload', () => clearInterval(intervalId))
  }
})
